import { render, staticRenderFns } from "./chatList.vue?vue&type=template&id=89ab571a&scoped=true&"
import script from "./chatList.vue?vue&type=script&lang=js&"
export * from "./chatList.vue?vue&type=script&lang=js&"
import style0 from "./chatList.vue?vue&type=style&index=0&id=89ab571a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ab571a",
  null
  
)

export default component.exports